
























































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    import courierCompanyList from '@/store/entities/back-couriercompany-list'
    class PageOrderRequest extends PageRequest {
        Shipment: string;
        BeginTime?: Date;
        EndTime?: Date;
        IsEnable?: Boolean;
        StartShipment: string;
        CourierCompanyId: number;
        constructor() {
            super();
        }
    }

    @Component({
        name: "courierExpressDeliveryList",
    })
    export default class CourierExpressDelivery extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [];
        whetherStatus = Enums.getEnum(Enums.WhetherStatus, true);
        CourierCompanyList: Array<courierCompanyList> = [];
        isShow: boolean = this.hasPermission("Statistical.Manages");
        get list() {
            return this.$store.state.courierExpressDelivery.list;
        };
        get loading() {
            return this.$store.state.courierExpressDelivery.loading;
        }
        pageChange(page: number) {
            this.$store.commit('courierExpressDelivery/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('courierExpressDelivery/setPageSize', pagesize);
            this.getpage();
        }
        async get() {
            
            this.CourierCompanyList = await this.$store.dispatch({
                type: 'couriercompany/getCourierCompanyList',
                data: {}
            });
            this.CourierCompanyList.unshift(new courierCompanyList, { companyId: null, companyCode: 0, companyName: "全部" })
        }


        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'courierExpressDelivery/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }

        async searchPage() {
            this.$store.state.courierExpressDelivery.currentPage = 1;
            this.getpage();
        }

        get pageSize() {
            return this.$store.state.courierExpressDelivery.pageSize;
        }
        get totalCount() {
            return this.$store.state.courierExpressDelivery.totalCount;
        }
        get currentPage() {
            return this.$store.state.courierExpressDelivery.currentPage;
        }
        async operationData(name: any, data: any) {
            if (name == "标记为无效") {
                 await this.$store.dispatch({
                    type: 'courierExpressDelivery/update',
                    data: { id: data.id }
                });
                this.getpage();
            }
        }

        columns = [
             {
                title: '快递单号',
                key: 'shipment',
                width: 150,

            }, {
                title: '快递公司',
                key: 'courierCompany',
                width: 150,
            }, {
                title: '备注',
                width: 150,
                key: 'reMark',
            }, {
                title: '入库时间',
                key: 'storageTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.storageTime ? DateUtils.formatLongDate(new Date(params.row.storageTime)) : '');
                }
            }, {
                title: '修改时间',
                key: 'updateTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.updateTime)));
                }
            },
            {
                title: '是否有效',
                key: 'isEnable',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', params.row.isEnable ? "有效" : '无效');
                }
            },
            {
                title: '操作',
                width: 100,
                fixed: 'left',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    var menu = [""];
                    if (data.isEnable) {
                        menu.push("标记为无效");;
                    }

                    return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    }

                                }),

                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )],
                        )
                    ]);
                }
            }]

        async created() {
            this.getpage();
            this.get();
        }
        async mounted() {
        }

         async exportExcel() {
            await this.$store.dispatch({
                type: 'courierExpressDelivery/exportExcel',
                data: this.pagerequest
            })
        }
    }
